module.exports = __webpack_public_path__ + "static/img/exit.75c6dbac.svg";